let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9iVad")).then(() => parcelRequire('9LuB2'));